<mat-card style="margin: 16px">
  <mat-card-content>

    <h1>THANKS FOR GIVING CONSENT</h1>
    <p style="font-size:30px"><b>InvitationToRegister</b></p>

    <button mat-raised-button color="primary" (click)="register()">I want to Register</button>
    <mat-card-actions>
    </mat-card-actions>

  </mat-card-content>
</mat-card>